import React, { useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'

interface SegmentButtonProps {
  partId: string
  currentId: string
  onClick: () => void
}

const SegmentButton = ({ partId, currentId, onClick }: SegmentButtonProps) => {
    const ref = useRef<HTMLButtonElement>(null)
    useEffect(() => {
        if (ref.current) {
            const elementToAnimate = ref.current.querySelector('svg > rect + rect') as SVGRectElement
            if (elementToAnimate) {
                if (currentId === partId) {
                    ref.current.classList.add('animated')
                    elementToAnimate.style.strokeDashoffset = '0px'
                    elementToAnimate.style.opacity = '1'
                } else {
                    ref.current.classList.remove('animated')
                    elementToAnimate.style.strokeDashoffset = '1px'
                    elementToAnimate.style.opacity = '0'
                }
            }
        }
    }, [currentId, partId])
    return (
        <button onClick={onClick} className='relative segment-button flex justify-center' ref={ref}>
            <svg viewBox='0 0 209 54' fill='none' width='209' height='54'>
                <rect opacity='0.2' x='0.5' y='0.5' width='208' height='53' rx='26.5' stroke='black' />
                <rect x='0.5' y='0.5' width='208' height='53' rx='26.5' stroke='black' pathLength='1' />
            </svg>
            <div className='w-[209px] h-[54px] absolute top-0 left-1/2 -translate-x-1/2 flex items-center justify-center'>
                <FormattedMessage id={`page.technology.${partId}`}>
                    {(value) => (
                        <h6
                            className={twMerge('segment-link transition', partId === currentId && 'opacity-100')}
                        >
                            {value}
                        </h6>
                    )}
                </FormattedMessage>
            </div>
        </button>
    )
}

export default SegmentButton
